import axiosInstance from '../AxiosClient'

const ENDPOINT = '/library-documents/'

export async function listLibraryDocuments() {
  const res = await axiosInstance.get(ENDPOINT)
  return res.data?.results ?? res.data
}

export async function listLibraryOrganizations() {
  const res = await axiosInstance.get(`${ENDPOINT}organizations/`)
  return res.data
}

export async function uploadLibraryDocument({ title, file, canvassingOrg }) {
  const form = new FormData()
  form.append('title', title)
  form.append('file', file)
  if (canvassingOrg) {
    form.append('canvassing_org', canvassingOrg)
  }
  const res = await axiosInstance.post(ENDPOINT, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return res.data
}

export async function deleteLibraryDocument(id) {
  await axiosInstance.delete(`${ENDPOINT}${id}/`)
}

export async function openLibraryDocument(id) {
  const res = await axiosInstance.get(`${ENDPOINT}${id}/open/`, {
    responseType: 'blob',
  })
  return res.data
}
